<div class="rfq-uom-form lum-modal">
  <form [formGroup]="form" (submit)="onSubmit()">
    <div class="lum-modal__header justify-space-between w-p100">
      <span class="lum-modal__header-title flex text-large"
        >Bulk Update Line Items Selling Unit
      </span>
      <div class="lum-modal__header-close">
        <button
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          mat-dialog-close
        >
          <lum-ui-icon
            class="mr-2-5"
            icon="close-circle"
            color="#5563D6"
            width="23"
            height="23"
          ></lum-ui-icon>
          Close
        </button>
      </div>
    </div>

    <mat-dialog-content>
      <div class="flex flex-column gap-2 mt-4">
        <div class="form-group">
          <div class="lum-label">Unit Class</div>
          <mat-select class="lum-select" formControlName="unitClassId">
            <mat-option>--None--</mat-option>
            <mat-option
              *ngFor="let unitClass of unitClasses; trackBy: trackById"
              [value]="unitClass.id"
              >{{ unitClass.name }}</mat-option
            >
          </mat-select>
        </div>
        <div class="form-group">
          <div class="lum-label">Ordered Unit of Measure</div>
          <mat-select class="lum-select" formControlName="uomId">
            <mat-option>--None--</mat-option>
            <mat-option
              *ngFor="
                let uom of currentUnitClass?.unitOfMeasures;
                trackBy: trackById
              "
              [value]="uom.id"
              >{{ uom.name }}</mat-option
            >
          </mat-select>
        </div>
      </div>

      <div *ngIf="unitClassIdControl?.value" class="text-center">
        <h5>
          {{ itemsWithSelectedClass?.length }} Product(s) with selected Unit Class
        </h5>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button
        type="button"
        class="lum-button lum-button--tertiary mr-2"
        mat-button
        mat-dialog-close
      >
        Cancel
      </button>
      <button mat-button type="submit" class="lum-button" [disabled]="form.invalid">
        Save
      </button>
    </mat-dialog-actions>
  </form>
</div>
